import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { CoreUiModule } from '@mg-platform/core/core-ui'
import { FilterFormComponent } from './components/filter-form/filter-form.component'
import { MainHeaderComponent } from './components/main-header/main-header.component'
import { RouterModule } from '@angular/router'
import { SvgIconsModule } from '@ngneat/svg-icon'
import { MatMenuModule } from '@angular/material/menu'
import { MatIconModule } from '@angular/material/icon'
import { ProfileLayoutComponent } from './components/profile-layout/profile-layout.component'
import { PageFilterHeaderComponent } from './components/page-filter-header/page-filter-header.component'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'
import { SideMenuComponent } from './components/side-menu/side-menu.component'
import { PageTitleComponent } from './components/page-title/page-title.component'
import { ShopSelectorDialogComponent } from './components/shop-selector-dialog/shop-selector-dialog.component'
import { ShopSelectorComponent } from './components/shop-selector/shop-selector.component'
import { RingChartComponent } from './components/ring-chart/ring-chart.component'
import { ElementSliderComponent } from './components/element-slider/element-slider.component'
import { SwiperModule } from 'swiper/angular'
import { ResponsiveSwitcherComponent } from './components/responsive-switcher/responsive-switcher.component'
import { CompareFilterComponent } from './components/compare-filter/compare-filter.component'
import { CompareWithDialogComponent } from './components/compare-with-dialog/compare-with-dialog.component'
import { CompareWithComponent } from './components/compare-with/compare-with.component'
import { RangeDatePickerFilterComponent } from './components/range-date-picker-filter/range-date-picker-filter.component'
import { RangeDatePickerDialogComponent } from './components/range-date-picker-dialog/range-date-picker-dialog.component'
import { RangeDatePickerComponent } from './components/range-date-picker/range-date-picker.component'
import { MatMomentDateModule, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter'
import {
  DefaultMatCalendarRangeStrategy,
  MAT_DATE_RANGE_SELECTION_STRATEGY,
  MatDatepickerModule
} from '@angular/material/datepicker'
import { CustomToastComponent } from './components/custom-toast/custom-toast.component'
import { IncludedShopsButtonComponent } from './components/included-shops-button/included-shops-button.component'
import { IncludedShopsComponent } from './components/included-shops/included-shops.component'
import { IncludedShopsDialogComponent } from './components/included-shops-dialog/included-shops-dialog.component'
import { RingChartAnimatableComponent } from './components/ring-chart-animatable/ring-chart-animatable.component'
import { DirectivesModule } from '@mg-platform/core/core-util'
import { WeekSelectorComponent } from './components/week-selector/week-selector.component'
import { WeekSelectorDialogComponent } from './components/week-selector-dialog/week-selector-dialog.component'
import { UpdateThemeCardComponent } from './components/update-theme-card/update-theme-card.component'
import { DynamicImagesComponent } from './components/dynamic-images/dynamic-images.component'
import { NoReportBannerComponent } from './components/no-report-banner/no-report-banner.component'
import { ShopFocusDialogComponent } from './components/shop-focus-dialog/shop-focus-dialog.component'
import { DynamicIconsComponent } from './components/dynamic-icons/dynamic-icons.component'
import { AddShopSectionsComponent } from './components/add-shop-sections/add-shop-sections.component'
import { AddShopFormComponent } from './components/add-shop/add-shop.component'
import { AddShopServicePriceComponent } from './components/add-shop-service-price/add-shop-service-price.component'
import { AddShopFocusComponent } from './components/add-shop-shop-focus/add-shop-focus.component'
import { AddShopProcessComponent } from './components/add-shop-process/add-shop-process.component'
import { DropdownMenuComponent } from './components/dropdown-menu/dropdown-menu.component'
import { CountryFlagComponent } from './components/country-flag/country-flag.component'
import { TableFilterComponent } from './widgets/table-filter/table-filter.component'
import { TableFiltersListComponent } from './widgets/table-filter/components/table-filters-list/table-filters-list.component'
import { TopMenuComponent } from './components/top-menu/top-menu.component'
import { SectionTitleComponent } from './components/section-title/section-title.component'
import { PercentageInfoComponent } from './components/percentage-info/percentage-info.component'
import { PillComponent } from './components/pill/pill.component'
import { InfoItemComponent } from './components/info-item/info-item.component'
import { TableSortComponent } from './components/table-sort/table-sort.component'
import { FooterComponent } from './components/footer/footer.component'
import { CardSortComponent } from './components/card-sort/card-sort.component'
import { SelectedDateTitleComponent } from './components/selected-date-title/selected-date-title.component'
import { ErrorMessageComponent } from './components/error-message/error-message.component'
import { ItemSelectorComponent } from './components/item-selector/item-selector.component'
import { ItemSelectorFilterComponent } from './components/item-selector-filter/item-selector-filter.component'
import { ItemSelectorDialogComponent } from './components/item-selector-dialog/item-selector-dialog.component'
import { MenuHeaderItemsComponent } from './components/menu-header-items/menu-header-items.component'
import { MatTooltipModule } from '@angular/material/tooltip'
import { InfoTooltipComponent } from './components/info-tooltip/info-tooltip.component'
import { MatBottomSheetModule } from '@angular/material/bottom-sheet'
import { DropdownBottomSheetComponent } from './components/dropdown-bottom-sheet/dropdown-bottom-sheet.component'
import { LoadingSpinnerComponent } from './components/loading-spinner/loading-spinner.component'
import { SidemenuBottomSheetComponent } from './components/sidemenu-bottom-sheet/sidemenu-bottom-sheet.component'

@NgModule({
  declarations: [
    FilterFormComponent,
    MainHeaderComponent,
    ProfileLayoutComponent,
    PageFilterHeaderComponent,
    SideMenuComponent,
    PageTitleComponent,
    MenuHeaderItemsComponent,
    ShopSelectorDialogComponent,
    ShopSelectorComponent,
    RingChartComponent,
    ElementSliderComponent,
    ResponsiveSwitcherComponent,
    CompareFilterComponent,
    CompareWithComponent,
    CompareWithDialogComponent,
    RangeDatePickerFilterComponent,
    RangeDatePickerDialogComponent,
    RangeDatePickerComponent,
    CustomToastComponent,
    IncludedShopsButtonComponent,
    IncludedShopsComponent,
    IncludedShopsDialogComponent,
    RingChartAnimatableComponent,
    WeekSelectorComponent,
    WeekSelectorDialogComponent,
    UpdateThemeCardComponent,
    NoReportBannerComponent,
    DynamicImagesComponent,
    ShopFocusDialogComponent,
    DynamicIconsComponent,
    AddShopFormComponent,
    AddShopSectionsComponent,
    AddShopFocusComponent,
    AddShopServicePriceComponent,
    AddShopProcessComponent,
    DropdownMenuComponent,
    CountryFlagComponent,
    TableFilterComponent,
    TableFiltersListComponent,
    TopMenuComponent,
    SectionTitleComponent,
    PercentageInfoComponent,
    PillComponent,
    InfoItemComponent,
    TableSortComponent,
    FooterComponent,
    CardSortComponent,
    SelectedDateTitleComponent,
    ErrorMessageComponent,
    ItemSelectorComponent,
    ItemSelectorFilterComponent,
    ItemSelectorDialogComponent,
    InfoTooltipComponent,
    DropdownBottomSheetComponent,
    LoadingSpinnerComponent,
    SidemenuBottomSheetComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    CoreUiModule,
    RouterModule,
    SvgIconsModule,
    MatMenuModule,
    MatIconModule,
    MatProgressSpinnerModule,
    SwiperModule,
    MatDatepickerModule,
    MatMomentDateModule,
    DirectivesModule,
    MatTooltipModule,
    MatBottomSheetModule
  ],
  exports: [
    FilterFormComponent,
    MainHeaderComponent,
    ProfileLayoutComponent,
    PageFilterHeaderComponent,
    SideMenuComponent,
    PageTitleComponent,
    RingChartComponent,
    ElementSliderComponent,
    ResponsiveSwitcherComponent,
    RangeDatePickerFilterComponent,
    CompareFilterComponent,
    CustomToastComponent,
    IncludedShopsButtonComponent,
    RingChartAnimatableComponent,
    UpdateThemeCardComponent,
    NoReportBannerComponent,
    DynamicImagesComponent,
    DynamicIconsComponent,
    TableFilterComponent,
    AddShopProcessComponent,
    DropdownMenuComponent,
    AddShopProcessComponent,
    CountryFlagComponent,
    TableFiltersListComponent,
    TopMenuComponent,
    SectionTitleComponent,
    PercentageInfoComponent,
    PillComponent,
    InfoItemComponent,
    TableSortComponent,
    FooterComponent,
    CardSortComponent,
    SelectedDateTitleComponent,
    ErrorMessageComponent,
    ItemSelectorFilterComponent,
    InfoTooltipComponent
  ],
  providers: [
    { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } },
    {
      provide: MAT_DATE_RANGE_SELECTION_STRATEGY,
      useClass: DefaultMatCalendarRangeStrategy
    }
  ]
})
export class CoreFeatureModule {}
